import React from 'react';
import type { IntlShape } from 'react-intl-next';

import type { ExtensionManifest, ExtensionModule } from '@atlaskit/editor-common/extensions';
import TemplateIcon from '@atlaskit/icon/core/app';

import { type Snippet } from '../snippetTypes';
import { messages } from '../messages';
import { extractSnippetKeywords } from '../snippetUtils';

type CreateSnippetExtensionProps = {
	snippets: Snippet[];
	intl: IntlShape;
};

export const snippetExtensionManifest = ({
	snippets,
	intl,
}: CreateSnippetExtensionProps): ExtensionManifest => {
	const quickInsert: ExtensionModule[] = snippets.map((snippet) => ({
		key: `snippet-${snippet.snippetId}`,
		title: snippet.name,
		description: intl.formatMessage(messages.snippetBy, { name: snippet.createdBy.displayName }),
		keywords: extractSnippetKeywords(snippet.name, intl),
		icon: async () => () => <TemplateIcon label="Snippet" />,
		action: async () => snippet.body,
	}));

	return {
		title: 'Snippets',
		description: 'Insert saved snippets into your page',
		type: 'com.atlassian.confluence.macro.core',
		key: 'snippet-extension',
		icons: {
			// eslint-disable-next-line import/dynamic-import-chunkname
			'48': () => import('@atlaskit/icon/core/app'),
		},
		modules: {
			quickInsert,
		},
	};
};
